import { Component, EventEmitter, OnInit, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { APP_POLICIES } from 'src/app/_constants/app.constants';
import { ObjectLiteral } from 'src/app/_models/user';
import { LanguageService } from 'src/app/_services/api/language/language.service';
import { SessionService } from 'src/app/_services/session/session.service';

@Component({
  selector: 'ua-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss']
})
export class CookieConsentComponent implements OnInit, OnDestroy {

  @Output('dismiss') dismiss = new EventEmitter();
  isConsentGiven: boolean;
  pageConstants: ObjectLiteral = {};
  languageSubscription: Subscription;
  
  readonly cookiePolicy = APP_POLICIES.cookiePolicy;

  constructor(
    private sessionService: SessionService,
    private languageService: LanguageService,
  ) {
    this.languageSubscription = this.languageService.languageChanges.subscribe(() => {
      this.pageConstants = this.languageService.constants?.commons || {};
    })
  }

  ngOnInit(): void {  
    this.isConsentGiven = true;//this.sessionService.loadCookieConsentFromStorage();
  }
  
  closeCookieConsent(): void {
    this.isConsentGiven = true;
    this.sessionService.storeCookieConsent();
    this.dismiss.emit();
  }

  ngOnDestroy() {
    this.languageSubscription && this.languageSubscription.unsubscribe();
  }
  
}
